import { Divider, Toolbar, Typography } from "@material-ui/core";
import { BackButton } from "../BackButton/BackButton";

export function MainScreenAppBar(props) {
  const { spinURL, id } = props;
  const spinFilename = spinURL.split("/").pop();
  return (
    <Toolbar style={{ backgroundColor: "white" }} id={id ?? "appbar-container"}>
      <BackButton />
      <Divider orientation="vertical" flexItem variant="middle" />
      <Typography>{spinFilename}</Typography>
      <div style={{ flex: 1 }} />
    </Toolbar>
  );
}
